import LegalConsentOptions from '../constants/legalConsentOptions';
const getIsLegitimateInterest = legalConsentOption => legalConsentOption === LegalConsentOptions.LEGITIMATE_INTEREST;
export default getIsLegitimateInterest;